module.exports = __webpack_public_path__ + "img/stop.90497a14.svg";